import axios from 'axios';
import * as environment from '../../../environment';
import { currentEnvironment, currentRegion } from '../../../helpers';

export interface PaypalCompleteCartData {
  success: boolean;
  data: {
    data: boolean;
  };
}

export interface PaypalCompleteCartResponse {
  response: PaypalCompleteCartData | null;
  error: any;
}

export const paypalCompleteCartAxios = async (
  clientId: string | undefined
): Promise<PaypalCompleteCartResponse> => {
  const region = currentRegion();
  const application = currentEnvironment();

  const externalGateway = environment.envApolloUrls[application].external;

  let error = null;
  let response = null;

  try {
    response = (await axios.post(
      externalGateway + '/v1/paypal/complete/cart',
      {
        cartClientId: clientId,
      },
      {
        headers: {
          'x-waldo-region': region,
        },
      }
    )) as PaypalCompleteCartData;
  } catch (errorResponse) {
    error = errorResponse;
  }

  return { response, error };
};
